import i18n from '@/lib/i18n/i18n';

import type { Step } from './types';

const STEPS: Step[] = [
  {
    id: 'party-section',
    target: '[data-onboarding-id="party-section"]',
    title: i18n.t('ONBOARDING_STEP_1_TITLE'),
    description: i18n.t('ONBOARDING_STEP_1_DESC'),
    placement: 'bottom',
  },
  {
    id: 'party-tab',
    target: '[data-onboarding-id="party-tab"]',
    title: i18n.t('ONBOARDING_STEP_2_TITLE'),
    description: i18n.t('ONBOARDING_STEP_2_DESC'),
    placement: 'bottom',
  },
  {
    id: 'ai-summary',
    target: '[data-onboarding-id="ai-summary"]',
    title: i18n.t('ONBOARDING_STEP_3_TITLE'),
    description: i18n.t('ONBOARDING_STEP_3_DESC'),
    placement: 'bottom',
  },
  {
    id: 'next-actions',
    target: '[data-onboarding-id="next-actions"]',
    title: i18n.t('ONBOARDING_STEP_4_TITLE'),
    description: i18n.t('ONBOARDING_STEP_4_DESC'),
    placement: 'bottom',
  },
  {
    id: 'create-actions',
    target: '[data-onboarding-id="create-actions"]',
    title: i18n.t('ONBOARDING_STEP_5_TITLE'),
    description: i18n.t('ONBOARDING_STEP_5_DESC'),
    placement: 'bottom',
  },
  {
    id: 'pin-sidebar',
    target: '[data-onboarding-id="pin-sidebar"]',
    title: i18n.t('ONBOARDING_STEP_6_TITLE'),
    description: i18n.t('ONBOARDING_STEP_6_DESC'),
    placement: 'bottom',
  },
];

export default STEPS;
